/**
 * 예외를 사용자에게 보일 한 줄로 바꿉니다.
 *
 * `catch (err: unknown)` 에서 바로 `err.message` 를 읽을 수 없어(타입이 unknown) 한 곳에 모읍니다.
 * 알 수 없는 값까지 문구로 바꾸는 이유는 네트워크 실패가 `TypeError` 로 오기도 하고, 그때
 * 화면이 빈 알림 배너를 띄우면 사용자가 무엇이 잘못됐는지 알 수 없기 때문입니다.
 */
export function messageOf(err: unknown): string {
  if (err instanceof Error && err.message) return err.message;
  return "알 수 없는 오류가 발생했습니다.";
}
